import { useEffect, useMemo, useState } from "react";

interface SelectionOption {
  value: string;
  label: string;
}

interface SelectionConfig {
  initialValue?: string;
}

const useSelection = <T extends SelectionOption>(options: T[], config?: SelectionConfig) => {
  const [value, setValue] = useState(config?.initialValue);

  useEffect(() => {
    if (!value) setValue(config?.initialValue);
  }, [config?.initialValue, value]);

  const selectedOption = useMemo(
    () =>
      options.find((option) => {
        return value === option.value;
      }),
    [options, value]
  );

  const selectableOptions = useMemo(
    () =>
      options.map((option) => {
        return {
          ...option,
          select: () => setValue(option.value),
          isSelected: option.value === value,
        };
      }),
    [options, value]
  );

  return {
    options: selectableOptions,
    selectedOption,
    select: setValue,
  };
};

export default useSelection;
